import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ArgumentosCargarArchivoValidacion } from "../models/cargaValidacion";

const listarCarga = async (data: File) => {
    const formData = new FormData();
    formData.append("archivoCsv", data);
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-dividendos/v1/minvu/listar-minvu-validacion`, formData);
    return response;
}
const cargarArchivo = async (data: ArgumentosCargarArchivoValidacion) => {
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-dividendos/v1/minvu/cargar-minvu-validacion`, data);
    return response;
}

export { listarCarga, cargarArchivo };